import React, { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import Loader from "components/Loader";
import { userService, utilService, portfolioService } from "services";
import { toast } from "react-toastify";

const PortfolioMedia = ({ user, setUser, selectedMachines }) => {
    const [portfolioImages, setPortfolioImages] = useState(Array(8).fill(""));
    const [youtubeLinks, setYoutubeLinks] = useState(Array(3).fill(""));
    const [loadingPortfolio, setLoadingPortfolio] = useState(false);
    const [loadingImages, setLoadingImages] = useState({});

    useEffect(() => {
        if (user) {
            const userImages = user?.portfolio?.images || [];
            if (userImages.length > 0) {
                let imgs = [...userImages];
                if (imgs.length < 8) {
                    imgs = [...imgs, ...Array(8 - imgs.length).fill("")];
                }
                setPortfolioImages(imgs.slice(0, 8));
            }

            const userLinks = [];
            if (user?.portfolio?.youtube_url_1)
                userLinks.push(user?.portfolio?.youtube_url_1);
            if (user?.portfolio?.youtube_url_2)
                userLinks.push(user?.portfolio?.youtube_url_2);
            if (user?.portfolio?.youtube_url_3)
                userLinks.push(user?.portfolio?.youtube_url_3);

            const finalLinks =
                userLinks.length > 0 ? userLinks : user?.youtubeLinks || [];

            if (finalLinks.length > 0) {
                let links = [...finalLinks];
                if (links.length < 3) {
                    links = [...links, ...Array(3 - links.length).fill("")];
                }
                setYoutubeLinks(links.slice(0, 3));
            }
        }
    }, [user]);

    const handlePortfolioImageUpload = async (e, index) => {
        const file = e.target.files[0];
        if (!file) return;
        const extension = file.name.split(".").pop();
        try {
            setLoadingImages((prev) => ({ ...prev, [index]: true }));
            const response = await utilService.getBucketUrl({
                location: "portfolio/",
                extension,
            });
            const { filename, url } = response.data.data[0];
            await utilService.uploadFile({
                url,
                requestOptions: {
                    method: "PUT",
                    headers: { "Content-Type": file.type },
                    body: file,
                    redirect: "follow",
                },
            });

            const newImages = [...portfolioImages];
            newImages[index] = filename;
            setPortfolioImages(newImages);
        } catch (err) {
            console.log(err);
            toast.error("Failed to upload image");
        } finally {
            setLoadingImages((prev) => ({ ...prev, [index]: false }));
        }
    };

    const handleVideoChange = (e, index) => {
        const newLinks = [...youtubeLinks];
        newLinks[index] = e.target.value;
        setYoutubeLinks(newLinks);
    };

    const getEmbedUrl = (url) => {
        if (!url) return "";
        let videoId = "";
        if (url.includes("watch?v=")) {
            videoId = url.split("watch?v=")[1].split("&")[0];
        } else if (url.includes("shorts/")) {
            videoId = url.split("shorts/")[1].split("?")[0];
        } else if (url.includes("youtu.be/")) {
            videoId = url.split("youtu.be/")[1].split("?")[0];
        } else if (url.includes("embed/")) {
            return url;
        }
        if (videoId) {
            return `https://www.youtube.com/embed/${videoId}`;
        }
        return url;
    };

    const handleSavePortfolio = async () => {
        try {
            setLoadingPortfolio(true);
            const payload = {
                images: portfolioImages,
                youtube_url_1: youtubeLinks[0] || "",
                youtube_url_2: youtubeLinks[1] || "",
                youtube_url_3: youtubeLinks[2] || "",
                drones: selectedMachines,
            };

            const res = await portfolioService.updatePortfolio(payload);
            const response = await userService.getUserProfile();
            if (response?.data?.data) {
                setUser(response.data.data);
                localStorage.setItem("userData", JSON.stringify(response.data.data));
                toast.success("Portfolio updated successfully");
            }
        } catch (err) {
            console.log(err);
            toast.error("Failed to update portfolio");
        } finally {
            setLoadingPortfolio(false);
        }
    };

    return (
        <div className="profile-cards mt-4" style={{ padding: "20px" }}>
            <div className="profie-heding d-flex justify-content-between align-items-center mb-4">
                <h4>Portfolio</h4>
                <button
                    className="btn btn-primary"
                    onClick={handleSavePortfolio}
                    disabled={loadingPortfolio}
                >
                    {loadingPortfolio ? "Saving..." : "Save Portfolio"}
                </button>
            </div>

            <h5 className="mb-3">Portfolio Images (8 Slots)</h5>
            <Row className="mb-4">
                {portfolioImages.map((img, idx) => (
                    <Col lg={3} md={4} sm={6} key={idx} className="mb-3">
                        <div
                            className="portfolio-upload-card"
                            style={{
                                width: "100%",
                                paddingTop: "100%",
                                position: "relative",
                                border: "2px dashed #e0e0e0",
                                borderRadius: "12px",
                                overflow: "hidden",
                                backgroundColor: "#f8f9fa",
                            }}
                        >
                            <label
                                htmlFor={loadingImages[idx] ? undefined : `portfolio-img-${idx}`}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: "100%",
                                    cursor: loadingImages[idx] ? "default" : "pointer",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                {loadingImages[idx] ? (
                                    <Loader loading={true} />
                                ) : img ? (
                                    <img
                                        src={`${user?.baseS3Url}${img}`}
                                        alt={`Portfolio ${idx}`}
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                ) : (
                                    <>
                                        <div style={{ fontSize: "24px", color: "#adb5bd" }}>+</div>
                                        <span className="text-muted small">Upload Image</span>
                                    </>
                                )}
                            </label>
                            <input
                                type="file"
                                id={`portfolio-img-${idx}`}
                                className="d-none"
                                accept="image/*"
                                disabled={loadingImages[idx]}
                                onChange={(e) => handlePortfolioImageUpload(e, idx)}
                            />
                            {img && !loadingImages[idx] && (
                                <button
                                    className="btn btn-sm btn-danger rounded-circle p-0 d-flex justify-content-center align-items-center"
                                    style={{
                                        position: "absolute",
                                        top: "5px",
                                        right: "5px",
                                        width: "24px",
                                        height: "24px",
                                        zIndex: 10,
                                    }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const newImgs = [...portfolioImages];
                                        newImgs[idx] = "";
                                        setPortfolioImages(newImgs);
                                    }}
                                >
                                    <span style={{ fontSize: "12px" }}>×</span>
                                </button>
                            )}
                        </div>
                    </Col>
                ))}
            </Row>

            <h5 className="mb-3">YouTube Videos</h5>
            <Row className="mb-4">
                {youtubeLinks.map((link, idx) => (
                    <Col lg={4} md={12} key={idx} className="mb-3">
                        <div className="p-3 border rounded-3 bg-white">
                            <label className="mb-2 fw-bold text-muted small">
                                Video Slot {idx + 1}
                            </label>
                            <input
                                type="text"
                                className="form-control mb-2"
                                placeholder="Paste YouTube Link"
                                value={link}
                                onChange={(e) => handleVideoChange(e, idx)}
                            />
                            {link ? (
                                <div className="ratio ratio-16x9 rounded overflow-hidden">
                                    <iframe
                                        src={getEmbedUrl(link)}
                                        title={`Video ${idx}`}
                                        allowFullScreen
                                    ></iframe>
                                </div>
                            ) : (
                                <div className="ratio ratio-16x9 bg-light rounded d-flex align-items-center justify-content-center text-muted small">
                                    Video Preview
                                </div>
                            )}
                        </div>
                    </Col>
                ))}
            </Row>
        </div>
    );
};

export default PortfolioMedia;
